import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/toolHero.css';
import './styles/featureReveal.css';
import App from './App';
import { LanguageProvider } from './context/LanguageContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);